/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mLang.vue?vue&type=template&id=3ad68780&scoped=true"
import script from "./mLang.vue?vue&type=script&lang=js"
export * from "./mLang.vue?vue&type=script&lang=js"
import style0 from "./mLang.vue?vue&type=style&index=0&id=3ad68780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad68780",
  null
  
)

export default component.exports